export default __webpack_public_path__ + "static/media/1.99fbf8fb.svg";